import React, { useContext } from 'react'
import { AppContext } from '../App'
import { missingImageUrl } from '../config.json'

export default function ProductCallout() {
   const { currentStep, productSelected, productOptionsSelected } = useContext(AppContext)
   const { step } = currentStep
   const { shortDescription, description, image, productImage } = productSelected || false
   const productName = productOptionsSelected.productOptions[2]
   const systemName = productOptionsSelected.productOptions[3]
    const systemType = productOptionsSelected.productOptions[4]


   const stepsToNotShow = [
      'productTypeSelection',
      'adhesivesProductSelection',
      'groutProductSelection',
      'resinousApplicationSelection',
      'resinousSystemSelection',
      'underlaymentProductSelection'
   ]

   const descriptionCleaned = description && description.replace('&nbsp;', ' ')
   // Prepend URL to image. If no image, but productImage is set (denotes Adhesive, Grout, or Underlayment), prepend a "/" to productImage value and create itemImage from that.
   const itemImage = image ? (
      "https://cdn.laticrete.com/" + image
      ) : (
         productImage ? (
            "https://cdn.laticrete.com/" + productImage
         ) : (
            missingImageUrl
         )
      )
  return (
   // Only show the product callout element if user is on an appropriate step.
   <div className={ stepsToNotShow.indexOf(step) > -1 ? "row product-callout-wrapper hidden" : "row product-callout-wrapper" }>
      <div className="col-xs-12 product-callout">
         { itemImage &&
         <div className="col-xs-12 col-sm-3 col-md-2 col-md-offset-2">
            <img alt="" src={ itemImage } className="img-responsive" />
         </div>
         }
         <div className={ itemImage ? "col-xs-12 col-sm-9 col-md-8" : "col-xs-12 col-md-8" } >
            { (systemType || systemName || productName) && <h4>{ systemType || systemName || productName } { shortDescription && <small>{ shortDescription }</small> }</h4> }
            { description && <p>{ descriptionCleaned && descriptionCleaned }</p> }
         </div>
      </div>
   </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/ProductCallout.js